// Cache for encryption key
const keyCache = new Map();

const getCachedKey = (user, passphrase) => {
  const cacheKey = `${user.uid}:${passphrase}`;
  if (!keyCache.has(cacheKey)) {
    keyCache.set(cacheKey, CryptoJS.SHA256(user.uid + passphrase).toString());
  }
  return keyCache.get(cacheKey);
};

export const getEncryptionSecret = (user, passphrase) => passphrase || user?.uid || "";

// Clear cache when passphrase changes (call from login/logout)
export const clearKeyCache = () => {
  keyCache.clear();
};

export const encryptText = async (text, user, passphrase) => {
  if (!text || !user || !passphrase) return text;
  return new Promise((resolve, reject) => {
    const worker = new Worker("/worker.js");
    worker.onmessage = (e) => {
      if (e.data.error) {
        reject(new Error(e.data.error));
      } else {
        resolve(e.data.result);
      }
      worker.terminate();
    };
    worker.onerror = (error) => {
      reject(new Error("Worker failed: " + error.message));
      worker.terminate();
    };
    worker.postMessage({ action: "encrypt", text, userUid: user.uid, passphrase });
  });
};

export const decryptText = async (text, user, passphrase, setDecryptionError) => {
  if (!text || !user || !passphrase || !text.startsWith("U2FsdGVkX1")) return text;
  return new Promise((resolve) => {
    const worker = new Worker("/worker.js");
    worker.onmessage = (e) => {
      if (e.data.error) {
        setDecryptionError("Some encrypted data could not be opened. If this is older data, log in with the optional encryption passphrase used when it was saved.");
        resolve("");
      } else {
        resolve(e.data.result);
      }
      worker.terminate();
    };
    worker.onerror = (error) => {
      setDecryptionError("Encrypted data could not be opened due to a browser worker error. Please try again.");
      resolve("");
      worker.terminate();
    };
    worker.postMessage({ action: "decrypt", text, userUid: user.uid, passphrase });
  });
};